import React, { useRef, useState } from 'react';
import { DropdownTrigger, Dropdown } from 'react-simple-dropdown';
import Tooltip from '@omilia/tooltip';
import { colors } from '@omilia/theme';

import {
  StyledHeaderMenuItemLabel as SHeaderMenuItemLabel,
  StyledHeaderMenuItemIcon as SHeaderMenuItemIcon,
  StyledMenuItem as SMenuItem,
  StyledDropdownContentBody as SDropdownContentBody,
  StyledDropdownContentHeaderTitle as SDropdownContentHeaderTitle,
  StyledDropdownContentHeader as SDropdownContentHeader,
} from 'components/HeaderDropdownMenu/styled';
import { FixModalOverflow } from 'components/styled';

// @ts-ignore
import useToggle from 'utils/hooks/useToggle';

import UploadProjectModal from './Modals/UploadProjectModal';
import UploadAndDeployProjectModal from './Modals/UploadAndDeployProjectModal';

import { SDropdownContent, SDropdown, SIcon } from './styled';

const DeploymentMenu = () => {
  const dropdownRef = useRef<React.RefObject<typeof Dropdown>>(null);

  const [
    uploadProjectModalIsOpen,
    { toggle: toggleUploadProjectModal },
  ] = useToggle();
  const [willDeploy, setWillDeploy] = useState(false);

  const hideMenu = () => {
    // @ts-ignore
    dropdownRef.current.hide();
  };

  const handleToggleUpload = () => {
    hideMenu();
    setWillDeploy(false);
    toggleUploadProjectModal();
  };

  const handleToggleUploadAndDeploy = () => {
    hideMenu();
    setWillDeploy(true);
    toggleUploadProjectModal();
  };

  return (
    <>
      <SDropdown ref={dropdownRef}>
        <DropdownTrigger>
          <Tooltip content="Deploy your work on dashboard" placement="left">
            <SIcon
              data-test="deployment-menu-button"
              glyph="deployment"
              // 15 is not on ui kit. We need to refactor all the dropdown triggers
              // on menu in order to use Icon from ui kit. After that we can
              // use size 14 to all of them
              size="16"
            />
          </Tooltip>
        </DropdownTrigger>

        <SDropdownContent>
          <SDropdownContentHeader>
            <SDropdownContentHeaderTitle>
              Deployment options
            </SDropdownContentHeaderTitle>
          </SDropdownContentHeader>

          <SDropdownContentBody>
            <Tooltip content="Upload your work on dashboard." placement="left">
              <SMenuItem
                as="a"
                data-test="deployment-export"
                onClick={handleToggleUpload}
              >
                <SHeaderMenuItemIcon className="icon-deployment-export" />
                <SHeaderMenuItemLabel data-test="upload-button">
                  Upload
                </SHeaderMenuItemLabel>
              </SMenuItem>
            </Tooltip>
            <Tooltip
              content="Upload your work on dashboard &amp; also choose the cluster you want to deploy it!"
              placement="left"
            >
              <SMenuItem
                as="a"
                data-test="upload-and-deploy-menu-item"
                onClick={handleToggleUploadAndDeploy}
              >
                <SIcon
                  color={colors.COLOR_OMILIA_BLUE_600}
                  data-test="upload-and-deploy-menu-item-icon"
                  glyph="deployment"
                  size="16"
                />
                <SHeaderMenuItemLabel data-test="upload-and-deploy-menu-item-button">
                  Upload & Deploy
                </SHeaderMenuItemLabel>
              </SMenuItem>
            </Tooltip>
          </SDropdownContentBody>
        </SDropdownContent>
      </SDropdown>

      <FixModalOverflow />

      {uploadProjectModalIsOpen && !willDeploy && (
        <UploadProjectModal
          willDeploy={willDeploy}
          onClose={toggleUploadProjectModal}
        />
      )}

      {uploadProjectModalIsOpen && willDeploy && (
        <UploadAndDeployProjectModal onClose={toggleUploadProjectModal} />
      )}
    </>
  );
};

export default DeploymentMenu;
